import * as React from 'react';
import type { PrimaryDropdownProps } from '../types';
import { DropdownLoadingSpinnerWrapper } from './dropdown-loading-spinner';
import { cn } from '@utils';

export const DropdownOptionsWrapper = <T,>({
	options,
	DropdownItemComponent,
	lastElementRef,
	isLoading,
	selected,
	onSelect,
	checkSelected,
}: Omit<PrimaryDropdownProps<T>, 'open' | 'setOpen' | 'disabled'>): JSX.Element => {
	return (
		<div
			className={cn(
				'flex h-full w-full flex-col items-center justify-start overflow-x-auto overflow-y-scroll',
				isLoading && !options?.length && 'justify-center'
			)}
		>
			{options?.map((option, index: number) => {
				const isLast: boolean = index === options.length - 1;

				return (
					<DropdownItemComponent
						option={option}
						key={index}
						onSelect={onSelect}
						isSelected={checkSelected ? checkSelected(option) : selected === option}
						ref={isLast ? lastElementRef : null}
					/>
				);
			})}
			{isLoading && <DropdownLoadingSpinnerWrapper />}
		</div>
	);
};
